import React from 'react';
import { Box, Heading } from '@chakra-ui/react';
import FormattedText from './FormattedText';
import LazyRichTextEditor from './LazyRichTextEditor';

const SummarySection = ({ isEditing, value, displayValue, onChange }) => (
  <Box bg="white" boxShadow="md" borderRadius="md" p={6} mb={6}>
    <Heading as="h2" size="md" mb={2}>
      Summary
    </Heading>
    {isEditing ? (
      <LazyRichTextEditor value={value} onChange={onChange} minH="120px" ariaLabel="Summary" />
    ) : (
      <FormattedText text={displayValue} />
    )}
  </Box>
);

export default SummarySection;
